// extracted by mini-css-extract-plugin
export default {"howItWorks":"responsiveStyles_howItWorks__ZLEgP","howItWorksInner":"responsiveStyles_howItWorksInner__7zpkw","steps":"responsiveStyles_steps__Du7ve"};